import React, { useState } from "react";
import { EventDataContext } from "../EventDataContext";
import { useContext } from "react";
import axios from "axios";
import { useEffect } from "react";
import { FaUserCircle } from "react-icons/fa";

import "../../styling/Dashboard.css";
import coverPic from "../../images/Profile-Banner.png";
import profilePhoto from "../../images/profilePhoto.jpg";
import profilePic from "../../images/happy-birthday-background-sign-tropical-beach-hawaii-63372910.jpg.webp";
import profilePicture from "../../images/John-Wick.jpg.avif";

import businessPhoto from "../../images/BoothBloom_Banner_Business.jpg";
import weddingPhoto from "../../images/BoothBloom_Banner_Wedding.jpg";
import birthdayPhoto from "../../images/BoothBloom_Banner_Birthday.jpg";
import otherPhoto from "../../images/BoothBloom_Banner_Other.jpg";

const LeftClientPanel = ({
  handleBackToAccount,
  clientData,
  brandingColours,
  selectedTab,
}) => {
  const primaryColor = "black";

  const buttonStyle = {
    display: "inline-block",
    padding: "10px, 20px",
    background: brandingColours?.primaryColor,
    color: brandingColours?.secondaryColor,
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    width: "75%",
    height: "35px",
    fontSize: "15px",
  };

  const { EventData, setEventData } = useContext(EventDataContext);
  const [clientDetails, setClientDetails] = useState("");

  // let coverPic = otherPhoto;
  // if (EventData.eventType == "corporate") {
  //   coverPic = businessPhoto;
  // } else if (EventData.eventType == "birthday") {
  //   coverPic = birthdayPhoto;
  // } else if (EventData.eventType == "wedding") coverPic = weddingPhoto;

  useEffect(() => {
    const fetchClientDetails = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/clientDetails/${EventData.userId}`,
          { withCredentials: true }
        );

        setClientDetails(response.data.data);
        console.log(clientDetails);
      } catch (error) {
        console.log("Error fetching client details:", error);
      }
    };

    if (EventData?.userId) {
      fetchClientDetails();
    }
  }, [EventData?.userId]);

  const clientInfo = (
    <div>
    <div style={{ position: "relative" }}>
  {/* Cover Photo */}
  <img
    src={coverPic}
    alt="cover"
    style={{
      width: "100%",
      height: "150px",
      objectFit: "cover",
      objectPosition: "center",
      borderTopLeftRadius: "8px",
      borderTopRightRadius: "8px",
    }}
  />

  {/* Profile Avatar (left side) */}
  <div
    style={{
      position: "absolute",
      bottom: "-25px",
      left: "15px",
      width: "60px",
      height: "60px",
      borderRadius: "50%",
      overflow: "hidden",
      backgroundColor: "#ffffff",
      border: "2px solid #ffffff",
      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "10px",
    }}
  >
    {clientDetails?.profilePic ? (
      <img
        src={clientDetails.profilePic}
        alt="Profile"
        style={{
          width: "110%",
          height: "110%",
          objectFit: "cover",
          transform: "translate(-5%, -5%)",
        }}
      />
    ) : (
      <FaUserCircle size={47} color="#bfbfbf" />
    )}
  </div>
</div>
      <div
        className="clientDataPanel"
        style={{ marginLeft: "25px", fontWeight: "500", color: primaryColor }}
      >
        <h2>{clientDetails && clientDetails.name ? clientDetails.name : ""}</h2>

        <h4 style={{ marginBottom: "-5px" }}>Phone</h4>
        <p style={{ color: "#625C73" }}>
          {/* {clientData && clientData.name ? clientData.phone : ""} */}
          {clientDetails?.phone}
        </p>

        <h4 style={{ marginBottom: "-5px" }}>Email</h4>
        <p style={{ color: "#625C73" }}>
          {/* {clientData && clientData.name ? clientData.email : ""} */}
          {clientDetails?.email}
        </p>

        <h4 style={{ marginBottom: "-5px" }}>Most Recent Booking</h4>
        <p style={{ color: "#625C73" }}>
          {/* Mar 21, 2024 */}
          {clientDetails?.mostRecentEventDate
            ? new Date(clientDetails.mostRecentEventDate).toLocaleDateString()
            : ""}
        </p>

        <h4 style={{ marginBottom: "-5px" }}>Total Events Booked</h4>
        <p style={{ color: "#625C73" }}>
          {/* 5 */}
          {clientDetails?.numberOfEvents}
        </p>
      </div>
      {selectedTab !== "landing" && (
        <div style={{ marginLeft: "25px", paddingBottom: "10px" }}>
          <button
            style={buttonStyle}
            onClick={handleBackToAccount}
            className="events-button-hover-underline"
          >
            {" "}
            View All Events{" "}
          </button>
        </div>
      )}
    </div>
  );

  return (
    <div>
      <div>{clientInfo}</div>
    </div>
  );
};

export default LeftClientPanel;
